<template>
  <div class="add_resources">
    <div :class="currentValue.length>6?'add_resources_head':'add_resources_head no_switch'">
      <div class="icon_box prev_icon">
        <span class="tagbar_icon" v-show="currentValue.length > 6" @click="prev()">
          <i class="el-icon-arrow-left"></i>
        </span>
      </div>
      <div class="tagBar">
        <draggable
          class="tagBars"
          :scroll="true"
          animation="200"
          v-model="currentValue"
          @update="sourceSort"
          tag="div"
        >
            <span
              class="tagbar_item"
              v-for="(item, index) in currentValue"
              :key="index"
              :class="{activeStyle:activeIndex === index}"
              @click="openThisTag(index, item)"
              ref="tagbarItem"
            >
            <span :class="(item.taskType == 1 ? 'isTask' : 'tagbar_item_span1')">{{index + 1}}</span>
            <el-input
              :ref="'edit' + index"
              v-if="eidtorNameStatus === index"
              style="width: 182px;margin-left: 3px"
              v-model="activeOne.tagName"
              size="mini"
              @click.stop
              @blur="handleSaveResource"
            ></el-input>
            <span v-else :title="item.tagName" class="tagbar_item_span2">{{item.tagName}}</span>
            <span
              v-if="activeIndex === index && eidtorNameStatus === -1 && !deleteOne && item.id"
              class="el-icon-edit-outline tagbar_item_span3"
              @click.stop="eidtorTagName(index)"
            ></span>
            <span
              v-if="(activeIndex === index && deleteOne) || !item.id"
              class="el-icon-close tagbar_item_span3"
              @click.stop="deleteThisTag(index, item)"
            ></span>
          </span></draggable>
      </div>
      <div class="icon_box next_icon">
        <span class="tagbar_icon" v-show="currentValue.length > 6">
          <i class="el-icon-arrow-right" @click="next()"></i>
        </span>
      </div>
      <div class="icon_box">
        <span class="tagbar_icon">
          <i class="el-icon-plus" @click="addOne()"></i>
        </span>
      </div>
      <span v-if="iseditor" class="add_resources_btn">
        <span class="zl_button zl_whiteButton" @click="cancel">取消</span>
        <span class="zl_button zl_blueButton" @click="handleSaveResource">保存</span>
      </span>
      <span v-else class="add_resources_btn">
        <span class="zl_button zl_blueButton" @click="eidtorThisTag">编辑</span>
      </span>
    </div>
    <!--编辑 iseditor === true 的时候是编辑状态  -->
    <transition v-if="iseditor" name="el-zoom-in-center">
      <div class="add_resources_show add_resources_bottom">
        <div class="add_resources_opt">
          <p class="add_resources_opt_item" style="display: flex;">
            <span class="label"><span class="rules">*</span>页面名称</span>
            <el-input
              style="width: 182px"
              v-model="activeOne.tagName"
              size="mini"
              placeholder="请输入内容"
            ></el-input>
            <span class="add_resources_opt_tips" style="width: 120px;"><img class="add_resources_icon"
                                                                            src="../../../../static/images/newCourseImages/tj.png"/> 推荐4个字</span>
            <span class="add_resources_opt_tips">
               <span style="width: 1px;height: 14px;background: #D2D2D7;margin-right: 10px"></span>
                 <img class="add_resources_icon" src="../../../../static/images/newCourseImages/swrw.png"/>
                 <span>设为任务：</span>
                <el-switch
                  v-model="activeOne.taskType"
                  :active-value="1"
                  :inactive-value="0"
                  active-color="#1890FF"
                  inactive-color="#D2D2D7"
                ></el-switch>
             </span>
            <span class="add_resources_opt_tips">
               <span style="width: 1px;height: 14px;background: #D2D2D7;margin-right: 10px"></span>
                 <img class="add_resources_icon" src="../../../../static/images/newCourseImages/swrw.png"/>
                 <span>显示素材名称：</span>
                <el-switch
                  v-model="activeOne.showFlag"
                  :active-value="1"
                  :inactive-value="0"
                  active-color="#1890FF"
                  inactive-color="#D2D2D7"
                ></el-switch>
             </span>
            <span class="add_resources_opt_tips" v-if="addType == 9">
                 <span>附件下载：</span>
                <el-switch
                  v-model="activeOne.previewType"
                  :active-value="0"
                  :inactive-value="1"
                  active-color="#1890FF"
                  inactive-color="#D2D2D7"
                ></el-switch>
             </span>

          </p>
          <p class="add_resources_opt_item" style="display: flex;">
            <span class="label">资源来源</span>
            <!-- 与课程新模式2 一致 标准模式下不展示可用资源库 -->
            <el-radio-group size="mini" v-model="resourcesFrom">
              <el-radio-button label="1">课程资源库</el-radio-button>
              <el-radio-button label="2" v-if="courseModel != 1">可用资源库</el-radio-button>
            </el-radio-group>

            <span v-if="resourcesFrom == 2" style="display: flex;align-items: center;margin-left: 20px;">
              <el-checkbox v-model="syncToCource">同步至课程资源库</el-checkbox>
               <span class="add_resources_opt_tips">
               <el-select
                 :disabled="!syncToCource"
                 v-model="categoryId"
                 placeholder="全部分类"
                 clearable
                 size="mini"
                 style="width: 155px;margin-left:8px;"
               >
                  <el-option
                    v-for="item in resourceDatas"
                    :key="item.id"
                    :label="item.categoryName"
                    :value="item.id"
                  ></el-option>
                </el-select>
               </span>
            </span>
            <!-- 科目 -->
            <!-- 课程资源库-资源库分类 || 科目资源库 -->
            <subject-select @subjectChange="subjectChange" class="subjectItem" v-if="courseModel != 1"></subject-select>

          </p>
          <p class="add_resources_opt_item two">
            <span class="label"><span class="rules">*</span>学习资源</span>
            <span
              class="itemTool"
              v-for="(item, index) in courseIcon"
              :key="index"
              :style="{
                borderColor:addType == item.type?item.color:'#ffffff',
              }"
              @click="addQuestionItem(item)"
            >
<!--              :class="{addTypeIndex:addType == item.type}"-->
              <img :src="'../../../static/images/newCourseImages/'+ item.image" :alt="item.alt"/>
              <span
                :style="{
                color:addType == item.type?item.color:'#0F0D11',
              }"
                class="itemLable">{{ item.alt }}</span>
            </span>
          </p>
        </div>
        <div class="add_resources_type">
          <transition name="el-zoom-in-center" v-if="addType == 9">
            <add-question
              ref="addQuestion"
              :addType="addType"
              course
              v-model="selectResourse"
              :courseId="courseId"
              :subjectId="subjectId"
              :resourcesFrom="resourcesFrom"
              qsType="2"
              @hhdTeacher="setTagName"
              :key="keyRefresh"
              :courseModel="courseModel"
            ></add-question>
          </transition>
          <!-- 作业 -->
          <transition name="el-zoom-in-center" v-else-if="addType == 11">
            <add-Work
              ref="addWork"
              showUpload
              :addType="addType"
              @hhdTeacher="setTagName"
              v-model="selectResourse"
              :courseId="courseId"
              :subjectId="subjectId"
              :resourcesFrom="resourcesFrom"
              :key="keyRefresh"
            ></add-Work>
          </transition>
          <transition name="el-zoom-in-center" v-else-if="addType == 10">
            <add-Paper
              ref="addPaper"
              showUpload
              :addType="addType"
              @hhdTeacher="setTagName"
              v-model="selectResourse"
              :courseId="courseId"
              :subjectId="subjectId"
              :resourcesFrom="resourcesFrom"
              :key="keyRefresh"
            ></add-Paper>
          </transition>
          <transition name="el-zoom-in-center" v-else>
            <course-resourse
              ref="courseResourse"
              v-model="selectResourse"
              @changeMaterialDialogVisible="changeMaterialDialogVisible"
              showUpload
              :courseId="courseId"
              :subjectId="subjectId"
              :resourcesFrom="resourcesFrom"
              :addType="addType"
              @hhdTeacher="setTagName"
              :key="keyRefresh"
            ></course-resourse>
          </transition>
        </div>
      </div>
    </transition>
    <!-- 展示 iseditor === false 的时候是展示 -->
    <transition v-else name="el-zoom-in-center">
      <div class="add_resources_show" style="background: #ffffff;">
        <newcourserender v-model="activeOne"></newcourserender>
      </div>
    </transition>
    <!-- 添加素材弹框 -->
<!--    <add-material :courseId="courseId" isInner :materialType="materialType" ref="addMaterial"-->
<!--                  :dialogVisible.sync="dialogVisible" :subjectId="subjectId"></add-material>-->
    <!-- 上传素材弹框 -->
    <uploadMaterial :courseId="courseId" isInner ref="uploadMaterial" :subjectId="subjectId"
                    :materialDialogVisible="materialDialogVisible"></uploadMaterial>
    <!-- 添加实操题/试卷弹窗 -->
<!--    <n-dialog-->
<!--      isField-->
<!--      showUpload-->
<!--      :title="dialogTitle"-->
<!--      :dialogVisible="addQuestionShow"-->
<!--      :width="dialogWidth"-->
<!--      :courseId="courseId"-->
<!--      :subjectId="subjectId"-->
<!--      :questionId="questionId"-->
<!--      :dialogType="dialogType"-->
<!--      :deleteNum="deleteNum"-->
<!--      :deleteName="deleteName"-->
<!--      @closeDialog="closeDialog"-->
<!--    ></n-dialog>-->
  </div>
</template>

<script>
  import courseResourse from "../../component/courseResourse";
  import addQuestion from "../../component/addQuestion";
  import addPaper from "../../component/addPaper";
  import addWork from "../../component/addWork.vue";
  // import addMaterial from "../../szrt_revision/new_course_module/editCourse/sourceMaterial/addMaterial";
  import uploadMaterial from "../../szrt_revision/new_course_module/editCourse/sourceMaterial/uploadMaterial"
  import * as sourceApi from "../../../api/sourceApi";
  import * as courseApi from "../../../api/courseApi";
  import newcourserender from "./new_course_render.vue";
  import addMixedMode from "../../single_resource_course/components/addMixedMode";
  import bus from "@/bus/bus.js";
  import * as api from "../../../api/courseApi";
  import draggable from "vuedraggable";
  import subjectSelect from "@/components/subject_select"

  export default {
    name: "add_resources",
    props: {
      data: {
        type: Array,
        default: () => [{}],
      },
      catalogue: {
        type: Object,
        default: () => {
        },
      },
      courseId: {
        type: [String, Number],
        default: 0,
      },
      // subjectId: {
      //   type: [String, Number],
      //   default: 0,
      // },
      // 是否修改状态
      editor: {
        type: Boolean,
        default: false,
      },
      refresh: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      courseResourse,
      addQuestion,
      addPaper,
      addWork,
      newcourserender,
      addMixedMode,
      draggable,
      // addMaterial,
      uploadMaterial,
      subjectSelect
    },
    data() {
      return {
        currentValue: this.data,
        courseIcon: [
          {
            image: "形状@2x(4).png",
            alt: "视频",
            type: 4,
            color: "#FF9543",
          },
          {
            image: "形状@2x(3).png",
            alt: "PPT",
            type: 1,
            color: "#9C95E3",
          },
          {
            image: "形状@2x(2).png",
            alt: "文档",
            type: 2,
            color: "#F49460",
          },
          {
            image: "形状@2x.png",
            alt: "富文本",
            type: 6,
            color: "#1890FF",
          },
          {
            image: "形状@2x(1).png",
            alt: "实操题",
            type: 9,
            color: "#20AE7A",
          },
          {
            image: "形状@2x(11).png",
            alt: "作业",
            type: 11,
            color: "#F49460",
          },
          {
            image: "形状@2x(5).png",
            alt: "测验",
            type: 10,
            color: "#1A8BFF",
          },
          {
            image: "形状@2x(6).png",
            alt: "图片",
            type: 7,
            color: "#1890FF",
          },
          {
            image: "形状@2x(7).png",
            alt: "其他",
            type: 8,
            color: "#20AE7A",
          },

        ],
        tagName: "未定义",
        eidtorNameStatus: -1, // 修改名称
        selectResourse: 0,
        addType: 0, // 1ppt，2文档和pdf，3音频， 4视频，5链接，6图文，7图片，8其他
        activeOne: {},
        iseditor: false,
        isAdd: false,
        // 图文
        imageText: [],
        //
        deleteOne: false,
        activeIndex: 0,
        editorId: "",
        scrollPage: 1,
        //
        isOne: true,
        dialogVisible: false,
        // materialType: '',


        // dialog
        // dialogTitle: "",
        // dialogWidth: "",
        // dialogType: "",
        // addQuestionShow: false,
        materialDialogVisible: {
          add: false,
          upload: false,
          delete: false,
          view: false
        },
        questionId: "",
        deleteNum: "",
        deleteName: "",
        //
        resourcesFrom: '1',
        syncToCource: true,
        resourceDatas: [],
        categoryId: '',
        catalogTypeForm:'',
        subjectId: '',
        keyRefresh: 0,
        courseModel: this.$route.query.courseModel, // 产品模式 1标准 2产品
      };
    },
    watch: {
      data: {
        handler(val) {
          this.currentValue = val;
          if (this.isAdd) {
            this.isAdd = false;
          }
          if (this.isOne) {
            this.init();
            this.isOne = false;
          }
        },
        immediate: true,
        deep: true,
      },
      refresh() {
        this.scrollPage = 1;
        this.init();
      },
    },
    created() {
      this.findResCategoryByCourseId();
      console.log(this.$route.query)
      this.catalogTypeForm=this.$route.query.from;
    },
    mounted() {
    },
    methods: {
      // 查询资源分类
      findResCategoryByCourseId() {
        sourceApi
          .FindResCategoryByCourseId(this.courseId)
          .then((res) => {
            if (res.code == "0") {
              this.resourceDatas = res.data;
              if (this.resourceDatas.length) {
                this.categoryId = this.resourceDatas[0].id
              }
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      },
      changeMaterialDialogVisible() {
        // sessionStorage.setItem('subjectId', this.$route.query.subjectId);
        this.materialDialogVisible.upload = true
      },
      initList() {
        if (this.addType == 10) {
          this.$refs.addPaper.handleCurrentChange()
        } else if (this.addType == 9) {
          this.$refs.addQuestion.handleCurrentChange()
        } else if (this.addType == 11) {
          this.$refs.addWork.handleCurrentChange()
        } else {
          this.$refs.courseResourse.handleCurrentChange()
        }
      },
      // closeDialog() {
      //   this.addQuestionShow = false;
      //   // this.findPageResource();
      // },
      init() {
        this.statusInit();
        if (this.currentValue.length == 1 && !this.currentValue[0].id) {
          this.$nextTick(() => {
            this.activeOne = JSON.parse(JSON.stringify(this.currentValue[0]));
            this.activeIndex = 0;
            this.addType = 4;
            this.iseditor = true;
          });
        } else if (this.currentValue.length) {
          let o = this.currentValue[this.currentValue.length - 1];
          if (!o.id) {
            this.activeIndex = this.currentValue.length - 1;
            this.activeOne = JSON.parse(JSON.stringify(this.currentValue[this.activeIndex]));
            this.addType = 4;
            this.iseditor = true;
          } else {
            let defualtopt = sessionStorage.getItem("new_sidebar_default");
            if (defualtopt) {
              let opt = JSON.parse(defualtopt);
              if (opt.tagIndex) {
                if (opt.tagIndex >= this.currentValue.length){
                  this.activeIndex = this.currentValue.length - 1;
                }else{
                  this.activeIndex = opt.tagIndex;
                }
              } else {
                this.activeIndex = 0;
              }
            } else {
              this.activeIndex = 0;
            }
            this.activeOne = JSON.parse(JSON.stringify(this.currentValue[this.activeIndex]));
            this.iseditor = this.editor;
            if (this.iseditor) {
              this.addType = this.activeOne.type
              this.selectResourse = this.activeOne.id
            }
          }

          this.handlescroll(this.activeIndex);
        } else {
          this.iseditor = true;
        }
        if (this.activeOne.previewType != 1) this.activeOne.previewType = 0;
        this.deleteOne = false;
      },
      addQuestionItem(o, i) {
        // this.materialType = '';
        this.addType = o.type;
        if (!this.editorId) this.$set(this.activeOne, 'tagName', o.alt);
        if (o.type == 6 && this.currentValue[i] && this.currentValue[i].id) {
          if (this.currentValue[i].imageText) {
            this.imageText = this.currentValue[i].imageText;
          } else {
            this.imageText = [];
          }
        } else {
          this.imageText = [];
        }
      },
      handleSaveResource() {
        //  editorId
        // console.log('--selectResourse--', this.selectResourse)
        if (!this.selectResourse) {
          return this.$message.warning("请选择资源");
        }
        if (!this.activeOne.tagName) {
          return this.$message.warning("请输入页面名称");
        }
        if (this.syncToCource && !this.categoryId) {
          return this.$message.warning("资源同步到课程资源库，请选择分类");
        }
        let resource = {
          catalogId: this.catalogue.id,
          courseId: this.courseId,
          catalogType:this.catalogTypeForm,
          list: [
            {
              catalogId: this.catalogue.id,
              courseId: this.courseId,
              resourceId: this.selectResourse,
              type: this.transformation(this.addType),
              tagName: this.activeOne.tagName,
              previewType: this.activeOne.previewType,  //  0下载 1预览
              showFlag:this.activeOne.showFlag,
              taskType:this.currentValue.taskType,
            },
          ],
        };
        if (this.editorId) {
          resource.list[0]["id"] = this.editorId;
          sourceApi.updateCatalogMaterial(resource).then((res) => {
            if (res.code == 0) {
              let defualtopt = sessionStorage.getItem("new_sidebar_default");
              if (defualtopt) {
                let opt = JSON.parse(defualtopt);
                opt["tagIndex"] = this.activeIndex;
                sessionStorage.setItem(
                  "new_sidebar_default",
                  JSON.stringify(opt)
                );
              }
              this.taskTypeChange();
              this.$messageSuccess("修改成功");
            } else {
              this.$messageWarning(res.msg);
            }
          });
        } else {
          sourceApi.submitMaterialBtn(resource).then((res) => {
            if (res.code == 0) {
              let defualtopt = sessionStorage.getItem("new_sidebar_default");
              if (defualtopt) {
                let opt = JSON.parse(defualtopt);
                opt["tagIndex"] = this.currentValue.length - 1;
                sessionStorage.setItem(
                  "new_sidebar_default",
                  JSON.stringify(opt)
                );
              }
              this.cancel();
              this.$messageSuccess("添加成功");
            } else {
              this.$messageWarning(res.msg);
            }
          });
        }

        if (this.syncToCource && this.resourcesFrom == 2) {
          let type = 2;
          if (this.addType == 9) {
            type = 3
          } else if (this.addType == 10) {
            type = 5
          } else {
            type = 2
          }
          let param = {
            categoryId: this.categoryId,
            resourceType: type,
            resourceIds: [this.selectResourse]
          }
          sourceApi.saveResourceBtn(param).then(res => {
            if (res.code == '0') {
              this.$message.success("保存到课程资源库成功");
            } else {
              this.$message.warning(res.msg);
            }
          }).catch(error => {
            console.log(error);
          })
        }


      },
      sourceSort(evt) {
        // 素材移动排序
        let param = [];
        this.currentValue.forEach((item, index) => {
          param.push({
            courseId: this.courseId,
            catalogId: this.catalogue.id,
            resourceId: item.id,
            sort: index,
          })
        })
        courseApi.putCatalogResourceSort(param).then(res => {
          if (res.code == 0) {
            // console.log('--evt--', evt.oldIndex, evt.newIndex)
            if (evt.oldIndex == this.activeIndex) {
              this.activeIndex = evt.newIndex;
            }
            this.$messageSuccess("移动成功");
          }
        })

      },
      cancel() {
        bus.$emit("businit");
        this.editorId = "";
        this.iseditor = false;
        this.deleteOne = false;
      },
      transformation(type) {
        //  1ppt，2文档 和 pdf，3音频， 4视频，5链接，6图文，7图片，8其他, 11作业
        if (type >= 1 && type <= 8) {
          return 1;
        } else if (type == 9) {
          return 3;
        } else if (type == 10) {
          return 5;
        } else if (type == 11) {
          return 11;
        }
      },
      openThisTag(i, o) {
        this.deleteOne = false;
        this.activeOne = JSON.parse(JSON.stringify(this.currentValue[i]));
        if (this.activeOne.previewType != 1) this.activeOne.previewType = 0;
        this.activeIndex = i;
        if (o.id) {
          this.addType = o.szrtType;
          this.iseditor = false;
          let defualtopt = sessionStorage.getItem("new_sidebar_default");
          if (defualtopt) {
            let opt = JSON.parse(defualtopt);
            opt["tagIndex"] = i;
            sessionStorage.setItem("new_sidebar_default", JSON.stringify(opt));
          }
        } else {
          this.statusInit();
          this.iseditor = true;
        }
      },
      eidtorTagName(i) {
        this.eidtorNameStatus = i;
        this.deleteOne = false;
        if (this.activeOne.resourceType && this.activeOne.resourceType == 3) {
          this.addType = 9;
        }else if (this.activeOne.resourceType && this.activeOne.resourceType == 5) {
          this.addType = 10;
        } else {
          this.addType = this.activeOne.type;
        }
        this.editorId = this.activeOne.courseResourceId;
        this.selectResourse = this.activeOne.id;
        this.$nextTick(() => {
          let that = this;
          let timer = setTimeout(() => {
            that.$refs["edit" + i][0].$refs.input.focus();
            clearTimeout(timer);
          }, 30);
        });
      },
      eidtorThisTag() {
        if (this.activeOne.id) {
          this.addType = this.activeOne.szrtType;
          this.selectResourse = this.activeOne.id;
          this.editorId = this.activeOne.courseResourceId;
          this.deleteOne = true;
        }
        this.iseditor = true;
      },
      deleteThisTag(i, o) {
        if (o.id) {
          this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              let params = {
                catalogId: this.catalogue.id,
                courseId: this.courseId,
                list: [o.courseResourceId],
              };
              courseApi.batchDeleteSource(params).then((res) => {
                if (res.code == 0) {
                  if (this.currentValue.length >= 2) {
                    let defualtopt = sessionStorage.getItem(
                      "new_sidebar_default"
                    );
                    if (defualtopt) {
                      let opt = JSON.parse(defualtopt);
                      opt["tagIndex"] = this.activeIndex - 1;
                      sessionStorage.setItem(
                        "new_sidebar_default",
                        JSON.stringify(opt)
                      );
                    }
                  }

                  this.cancel();
                  this.$messageSuccess("删除成功");
                } else {
                  this.$messageWarning(res.msg);
                }
              });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消删除",
              });
            });
        } else {
          this.currentValue.splice(i, 1);
          if (this.currentValue.length) {
            this.activeIndex = i - 1;
            this.$set(this, "activeOne", this.currentValue[this.activeIndex]);
            if (this.activeOne.id) {
              this.iseditor = false;
              this.deleteOne = false;
            }
          } else {
            this.cancel();
          }
        }
      },
      addOne() {
        this.isAdd = true;
        this.currentValue.push({
          tagName: "视频",
          taskType: 1,
          previewType: 0,
        });
        this.selectResourse = '';
        this.editorId = '';
        this.addType = 4;
        this.activeIndex = this.currentValue.length - 1;
        this.activeOne = JSON.parse(JSON.stringify(this.currentValue[this.activeIndex]));
        this.iseditor = true;
        this.deleteOne = true;
        this.handlescroll(this.activeIndex);
        this.editorId = "";
        this.scrollPage = Math.ceil(this.currentValue.length / 6);

      },
      prev() {
        let total = Math.ceil(this.currentValue.length / 6);
        if (this.scrollPage === 1) {
          return;
        } else if (this.scrollPage === 2) {
          this.handlescroll(0);
        } else if (this.scrollPage === total) {
          this.handlescroll(this.currentValue.length - 12);
        } else {
          let n = total - this.scrollPage;
          this.handlescroll(this.currentValue.length - 12 - n * 6);
        }
        this.scrollPage--;
      },
      next() {
        let total = Math.ceil(this.currentValue.length / 6);
        if (this.scrollPage === total) {
          return;
        } else if (this.scrollPage === total - 1) {
          this.handlescroll(this.currentValue.length - 1);
        } else if (this.scrollPage === 1) {
          this.handlescroll(11);
        } else {
          this.handlescroll(5 + this.scrollPage * 6);
        }
        this.scrollPage++;
      },
      taskTypeChange() {
        let obj = {
          catalogId: this.catalogue.id,
          courseId: this.courseId,
          "list": [this.activeOne.courseResourceId],
          "taskType": this.activeOne.taskType,
        }
        api.batchChangeCheck(obj)
          .then(rs => {
            if (rs.code == 0) {
              this.cancel();
              // this.$messageSuccess('设置成功')
            } else {
              this.$messageError(rs.msg)
            }
          })
      },
      setTagName(row) {
        let tagName = row.name || row.taskName || row.paperName || (row.questionContent ? this.$delHtmlTag.delHtmlTag(row.questionContent).substring(0,10) : "")
        if (tagName) {
          this.$set(this.activeOne, 'tagName', tagName);
        }
      },
      statusInit() {
        this.eidtorNameStatus = -1;
        // this.addType = 4;
        this.imageText = [];
        this.selectResourse = "";
      },
      // 点击导航菜单，页面滚动到指定位置
      handlescroll(index) {
        this.$nextTick(() => {
          this.$refs.tagbarItem[index].scrollIntoView({
            behavior: "smooth", // 平滑过渡
            // block: "center", // 上边框与视窗顶部平齐。默认值
          });
        });
      },
      subjectChange(curId) {
        this.subjectId = curId;
        this.keyRefresh++;
      },
      // addQues(num) {
      //   if (num == 10) { //测验
      //     this.materialType = num
      //     this.dialogTitle = "添加试卷";
      //     this.dialogWidth = "850px";
      //     this.dialogType = "addTestPaper";
      //     this.addQuestionShow = true;
      //   } else {
      //     this.materialType = num
      //     this.dialogVisible = true
      //     this.$refs['addMaterial'].dialogVisible = true
      //   }
      // },
    },
  };
</script>

<style scoped lang="scss">
  .add_resources {
    height: 100%;
    overflow: hidden;

    .add_resources_head {
      background: #f5f5f7;
      display: flex;

      .icon_box {
        width: 30px;
        line-height: 36px;
        text-align: center;
      }

      .tagBar {
        max-width: 755px;
        height: 36px;
        /*overflow: hidden;*/
        overflow-y: hidden;
        overflow-x: auto;

        .tagBars {
          height: 36px;
          /*width: 200000px;*/
          display: flex;
        }

        .tagbar_item {
          /*float: left;*/
          /*width: 306px;*/
          min-width: 106px;
          height: 36px;
          padding: 0 7px;
          margin: 0 3px;
          display: flex;
          align-items: center;
          border-radius: 10px 10px 0px 0px;
          cursor: pointer;
          /*opacity: 3;*/
          background: rgba(255, 255, 255, 0.7);
          box-shadow: 0px -2px 6px 0px rgba(209, 216, 220, 0.24);

          .tagbar_item_span1 {
            width: 16px;
            height: 16px;
            min-width: 16px;
            line-height: 16px;
            text-align: center;
            background: #ffffff;
            box-shadow: 0px 0px 1px 1px #1890FF;
            border-radius: 16px;
            color: #1890FF;
            font-size: 11px;
            opacity: 0.5;
          }

          .isTask {
            width: 16px;
            height: 16px;
            min-width: 16px;
            line-height: 16px;
            text-align: center;
            background: #1890FF;
            box-shadow: 0px 0px 1px 1px #1890FF;
            border-radius: 16px;
            color: #ffffff;
            font-size: 11px;
            opacity: 0.37;
          }

          .tagbar_item_span2 {
            min-width: 65px;
            max-width: 170px;
            line-height: 34px;
            height: 36px;
            padding: 0 3px;
            color: #767484;
            text-align: left;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            word-break: break-all;
          }

          .tagbar_item_span3 {
            font-size: 17px;
          }

          .el-icon-edit-outline {
            color: #595964;

            &:hover {
              color: #1890FF;
            }
          }

          .el-icon-close {
            color: rgba($color: #595964, $alpha: 0.5);

            &:hover {
              color: #1890FF;
            }
          }
        }

        .activeStyle {
          background: #ffffff;

          .tagbar_item_span1 {
            background: #ffffff;
            color: #1890ff;
            opacity: 1;
          }

          .isTask {
            background: #1890ff;
            color: #ffffff;
            opacity: 1;
          }

          .tagbar_item_span2 {
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #42414d;
          }
        }
      }

      .tagbar_icon {
        display: inline-block;
        width: 20px;
        height: 20px;
        line-height: 19px;
        text-align: center;
        font-size: 17px;
        color: #42414d;
        border-radius: 4px;
        background: #e4e4e6;
        cursor: pointer;

        &:hover {
          color: #409eff;
          background: #d9ecff;
        }
      }

      .add_resources_btn {
        flex: 1;
        text-align: right;
        line-height: 36px;
      }
    }

    .no_switch {
      .next_icon {
        width: 2px;
      }

      .tagBar .tagBars .tagbar_item {
        &:first-child {
          margin-left: 0;
        }
      }
    }

    .add_resources_bottom {
      display: flex;
      flex-direction: column;
      overflow: auto;
    }

    .add_resources_opt {
      padding: 10px 0;
      background: #ffffff;
      border-radius: 4px;
      margin-bottom: 10px;

      .two {
        display: flex;
      }

      .add_resources_opt_item {
        margin-top: 10px;

        .label {
          display: inline-block;
          width: 120px;
          text-align: right;
          padding-right: 10px;
          color: #0F0D11;
          line-height: 28px;

          .rules {
            color: red;
            padding: 3px;
          }
        }

        .itemTool {
          border: 1px solid #dcdfe6;
          text-align: center;
          display: inline-block;
          margin-right: 10px;
          margin-left: 4px;
          padding: 5px;
          border-radius: 4px;
          cursor: pointer;
          height: 80px;
          width: 76px;

          img {
            width: 38px;
            height: 36px;
            display: block;
            margin: 7px auto;
          }

          .itemLable {
            display: block;
            height: 17px;
            line-height: 17px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #0f0d11;
          }

          &:hover {
            border: 1px solid #ff9543;

            span {
              color: #ff9543;
            }
          }
        }

        .addTypeIndex {
          border: 1px solid #ff9543;

          .itemLable {
            color: #ff9543;
          }
        }

        .add_resources_opt_tips {
          display: flex;
          align-items: center;
          font-family: PingFangSC-Regular, PingFang SC;
          font-size: 12px;
          font-weight: 400;
          color: #999999;
          padding-left: 10px;
        }

        .subjectItem {
          padding-left: 8px;
        }
      }
    }

    .add_resources_type {
      flex: 1;
      overflow: auto;
      padding: 10px 20px;
      background: #ffffff;
      border-radius: 4px;
    }

    .add_resources_show {
      height: calc(100% - 36px);
    }

    .add_resources_icon {
      width: 14px;
      height: 14px;
      margin: 0 2px;
    }
  }
</style>
<style>
  .tagBar::-webkit-scrollbar {
    height: 0px !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/new_course_editor/components/add_resources.vue